import React, { Fragment } from 'react';
import * as Styles from './BreadCrumbs.styles';
import { IconChevron } from 'gatorcomponents';

const BreadCrumbs = ({ breadCrumbs }) => (
  <Styles.Breadcrumbs>
    {breadCrumbs.map((item, index) => (
      <Fragment key={item.label}>
        <Styles.Breadcrumb onClick={item.onClick}>
          <span>{item.label}</span>
        </Styles.Breadcrumb>
        {index < breadCrumbs.length - 1 && <IconChevron direction="right" />}
      </Fragment>
    ))}
  </Styles.Breadcrumbs>
);

export default BreadCrumbs;
